import { PlanningAssignment, PlanningResourceNeed } from './types';

// Badge de cobertura d'una fase a partir de les seves necessitats i
// assignacions — usat a CronogramaGrid.tsx i GeneralTab.tsx per pintar un
// indicador ràpid al costat del nom de la fase.
export interface CoverageBadge {
  text: string;
  className: string;
}

export function coverageBadge(needs: PlanningResourceNeed[], assignments: PlanningAssignment[]): CoverageBadge | null {
  const hasConflict = assignments.some((a) => !!a.conflictOverride);
  if (needs.length === 0) {
    if (assignments.length === 0) return null;
    return { text: `${assignments.length}`, className: hasConflict ? 'bg-red-100 text-red-700' : 'bg-red-50 text-red-600' };
  }
  const total = needs.reduce((acc, n) => acc + n.quantity, 0);
  const covered = needs.reduce((acc, n) => acc + Math.min(n.quantity, assignments.filter((a) => a.resourceNeedId === n.id).length), 0);
  const className = hasConflict
    ? 'bg-red-100 text-red-700'
    : covered >= total && total > 0
      ? 'bg-green-100 text-green-700'
      : covered > 0
        ? 'bg-amber-100 text-amber-700'
        : 'bg-red-100 text-red-700';
  return { text: `${covered}/${total}`, className };
}
